import jquery from 'jquery';

// fix for "Does not use passive listeners to improve scrolling performance"
jquery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener('touchstart', handle, { passive: !ns.includes('noPreventDefault') });
  },
};
jquery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') });
  },
};
jquery.event.special.wheel = {
  setup: function (_, ns, handle) {
    this.addEventListener('wheel', handle, { passive: true });
  },
};
jquery.event.special.mousewheel = {
  setup: function (_, ns, handle) {
    this.addEventListener('mousewheel', handle, { passive: true });
  },
};

/**
 * Extension isOnScreen
 */

jquery.fn.isOnScreen = function () {
  var win = $(window);

  var viewport = {
    top: win.scrollTop(),
    left: win.scrollLeft(),
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();

  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();

  return !(
    viewport.right < bounds.left ||
    viewport.left > bounds.right ||
    viewport.bottom < bounds.top ||
    viewport.top > bounds.bottom
  );
};

/**
 * Extension: isScrolling
 */
jquery.fn.isScrolling = function () {
  console.log('is scrolling');
  var status = true;
  clearTimeout($.data(this, 'scrollCheck'));
  jquery.data(
    this,
    'scrollCheck',
    setTimeout(function () {
      status = false;
      return status;
    }, 250)
  );
};

/**
 * Extension: scrolled
 */
jquery.fn.scrolled = function (func, detectEndOfScrolling) {
  if (typeof detectEndOfScrolling === 'undefined') {
    detectEndOfScrolling = false;
  }

  jquery(document).on('scroll', function () {
    function execute(func) {
      if (func != undefined && typeof func == 'function') {
        func();
      }
    }

    if (detectEndOfScrolling) {
      clearTimeout($.data(this, 'scrollCheck'));
      jquery.data(
        this,
        'scrollCheck',
        setTimeout(function () {
          execute(func);
        }, 250)
      );
    } else {
      execute(func);
    }
  });
};

export default window.$ = window.jQuery = jquery;
